/* src/app/ships/access-details/access-details.component.css */
input.ng-invalid.ng-touched {
  border: 1px solid red;
}
/*# sourceMappingURL=access-details.component.css.map */
